import { isNull, isNumber, isString } from 'lodash';

/**
 * @deprecated The method should not be used
 */
export function makeReadable(data: unknown): string {
  if (isString(data)) {
    return data;
  }
  if (isNumber(data)) {
    return data.toString();
  }

  if (data instanceof Date) {
    return data.toLocaleDateString();
  }

  if (typeof data == 'boolean') {
    return data ? 'Vrai' : 'Faux';
  }

  if (isNull(data)) {
    return 'Non renseigné';
  }
  return '';
}
